import type { ValueTransformer } from 'typeorm';

/**
 * Maps a MySQL `decimal` column to a JavaScript number. The driver returns
 * decimals as strings to avoid precision loss, so without this a credit
 * total reaches its readers as `"12.5000"` and `a + b` concatenates.
 *
 * Only for columns whose precision a double holds exactly enough: the AI
 * usage ledger's `decimal(14,4)` credits and `decimal(12,6)` dollar costs,
 * and the `decimal(15,4)` invoice line quantity, are inside the 15
 * significant digits a double keeps.
 */
export const decimalNumber: ValueTransformer = {
	to: (value: number | null | undefined): number | null | undefined => value,
	from: (value: string | number | null): number | null => {
		if (value == null) {
			return null;
		}

		const parsed = typeof value === 'number' ? value : Number(value);

		return Number.isFinite(parsed) ? parsed : null;
	},
};
